import urlResolver from 'edrolo/utils/URLResolver';
import Request from 'core/api/Request';
import { createContext, useContext } from 'react';

export async function uploadUserDrawingAsset(
  file,
  assetId // uuid generated by tldraw
) {
  const url = urlResolver.reverse('api:activities:upload-user-drawing-asset');
  const response = await Request.post(url)
    .field('assetId', assetId)
    .attach('file', file)
    .end();

  if (response.ok) {
    return response.body;
  }
  throw response;
}

export const fileToBase64 = (file) =>
  // This is what tldraw uses as a default internally.
  // Copied here and modified to suit so we can explicitly choose it.
  // From https://github.com/tldraw/tldraw/blob/main/packages/tldraw/src/state/data/filesystem.ts
  new Promise((resolve, reject) => {
    if (file) {
      const reader = new FileReader(); // eslint-disable-line no-undef
      reader.readAsDataURL(file);
      reader.onload = () => resolve({ url: reader.result });
      reader.onerror = (error) => reject(error);
      reader.onabort = (error) => reject(error);
    }
  });

export const AssetUploadContext = createContext(uploadUserDrawingAsset);

export const useAssetUploader = () => ({
  assetUploadHandler: useContext(AssetUploadContext),
});
